// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentsV1DocumentUploadUploadResponse {
    static getAttributeTypeMap() {
        return DocumentsV1DocumentUploadUploadResponse.attributeTypeMap;
    }
}
DocumentsV1DocumentUploadUploadResponse.discriminator = undefined;
DocumentsV1DocumentUploadUploadResponse.additionalProperties = false;
DocumentsV1DocumentUploadUploadResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=documentsV1DocumentUploadUploadResponse.js.map